import { render, staticRenderFns } from "./DescriptionView.vue?vue&type=template&id=dea75eae&"
import script from "./DescriptionView.vue?vue&type=script&lang=js&"
export * from "./DescriptionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports